module.exports = __webpack_public_path__ + "static/media/place2Icon.fb40d01f.svg";